(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-sales-letter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-faq-sales-letter]');
    if (!root) return;

    const items = Array.from(root.querySelectorAll('details.faq-sales-letter__item'));

    // Toggle per Klick auf Summary, optional: immer nur ein Item offen
    root.addEventListener('click', (e) => {
      const summary = e.target.closest('summary.faq-sales-letter__summary');
      if (!summary || !root.contains(summary)) return;

      e.preventDefault();

      const details = summary.closest('details.faq-sales-letter__item');
      if (!details) return;

      const willOpen = !details.hasAttribute('open');

      // Close others
      items.forEach((it) => {
        if (it !== details) it.removeAttribute('open');
      });

      if (willOpen) {
        details.setAttribute('open', '');
        // Scroll-Fix für iOS: Fokus nicht springen lassen
        summary.blur();
      } else {
        details.removeAttribute('open');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.announcement_bar = document.querySelector('.announcement-bar-section');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.announcement_bar.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.announcement_bar.classList.add('shopify-section-header-sticky', 'animate');
      this.announcement_bar.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-description"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = Array.from(document.querySelectorAll('[data-product-description]'));
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.productDescriptionInit === '1') return;
      root.dataset.productDescriptionInit = '1';

      const items = Array.from(root.querySelectorAll('details.product-description__item'));
      if (!items.length) return;

      // Per Klick öffnen/schließen + nur ein Element gleichzeitig offen
      root.addEventListener('click', (e) => {
        const summary = e.target.closest('summary.product-description__summary');
        if (!summary || !root.contains(summary)) return;

        e.preventDefault();

        const details = summary.closest('details.product-description__item');
        if (!details) return;

        const willOpen = !details.hasAttribute('open');

        items.forEach((it) => {
          if (it !== details) it.removeAttribute('open');
        });

        if (willOpen) {
          details.setAttribute('open', '');
          summary.blur();
        } else {
          details.removeAttribute('open');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
